import { defineComponent, h } from 'vue';

import { Station } from '~/api/models/station.model';
import { NButton, useNotification, useLoadingBar } from 'naive-ui';
import { mapStores } from 'pinia';
import moment from 'moment';
import { useStationStore } from '~/store/station.store';


export default defineComponent({

    components: {
        NButton,
    },

    data() {
        return {
            notifications: useNotification(),
            loader: useLoadingBar(),
        }
    },

    computed: {
        ...mapStores(useStationStore),
    },

    methods: {
        getStationName(station: Station): string {
            return station?.metadata['elichens/public/label'] as string || station?.name || '-';
        },

        isStationAllowed(stationIds: string | string[]) {
            if(Array.isArray(stationIds)) {
                return stationIds.every(id => this.stationStore.allStations.map(s => s.id).includes(id))
            } else {
                return this.stationStore.allStations.map(s => s.id).includes(stationIds);
            }
        },


        showLoading<T>(promise?: Promise<T>): Promise<T> | void {
            if(promise) {
                this.loader.start();
                promise
                    .catch(() => this.loader.error())
                    .finally(() => this.loader.finish())
            } else {
                this.loader.start();
            }
        },

        hideLoading(): void {
            this.loader.finish();
        },

        /**
         * Remove any forbidden station from url query
         */
        cleanQuery(): void {
            let stations: string | string[] = this.$route.query?.stations;
            if(stations && Array.isArray(stations)) {
                stations = stations.filter(s => this.isStationAllowed(s));
            } else {
                stations = this.isStationAllowed(stations) ? stations: this.stationStore.stations[0]?.id;
            }

            this.$router.replace({path: this.$route.path, query: { ...this.$route.query, station: stations}})
        },

        showUnhandledError(message: string, error?: Error) {
            this.$notifyError(message, error);
        },

        success(message: string) {
            this.notification('success', null, message);
        },

        notification(type: 'error' | 'info' | 'success' | 'warning', title?: string, message?: string, action?: { label: string, callback: () => void}) {
            const notification = this.notifications.create({
                title,
                type,
                content: () => h('span', null, [message]),
                meta: moment().format('lll'),
                duration: 5000,
                action: action ? () => {
                    return h(
                        NButton,
                        {
                            text: true,
                            type: 'primary',
                            onClick: () => {
                                action.callback();
                                notification.destroy();
                            },
                        },
                        {
                            default: () => action.label
                        }
                    )   
                } :  null,
            })
        },
    }
})